<template>
    <div class="">
        <slot name="before" :uploadProgress="uploadProgress" :isLoading="isLoading" :isUploaded="isUploaded">
        </slot>
        <div :class="containerClassName" ref="videoContainer">
            <slot name="video" :className="className" :videoBlob="videoBlob" :uploadProgress="uploadProgress" :isLoading="isLoading" :isUploaded="isUploaded" :showOnlineRecords="showOnlineRecords">
                <video id="myVideo" :class="className" ref="video"></video>
                <div class="bg-black-trasparent d-flex h-100 position-absolute top w-100 px-lg-6 px-xl-10" v-if="showControls">
                    <div class="align-items-center d-flex flex-fill h-100 justify-content-center">
                        <a href="#" @click.prevent="playVideo" class="text-center" v-if="videoBlob">
                            <img :src="iconStartRecording" class="img-fluid">
                            <div class="text-white text-center pt-3">
                                {{ labelPlayVideo }}
                            </div>
                        </a>
                        <a href="#" @click.prevent="startRecording" class="text-center" v-else>
                                <img :src="iconStartRecording" class="img-fluid">
                                <div class="text-white text-center pt-3">
                                    {{ labelStartRecording }}
                                </div>
                        </a>
                    </div>
                    <div class="align-items-center d-flex flex-fill h-100 justify-content-center" v-if="videoBlob">
                        <a href="#" @click.prevent="startRecording" class="text-center">
                            <img :src="iconRecordAgain" class="img-fluid">
                            <div class="text-white text-center pt-3">
                                {{ labelRecordAgain }}
                            </div>
                        </a>
                    </div>
                </div>
                <div class="bg-white-trasparent d-flex h-100 position-absolute top w-100" v-if="showCountdown">
                    <div class="align-items-center flex-fill h-100 justify-content-center">
                        <div class="text-gray-dark text-center display-1 font-weight-bold pt-4 pt-lg-6 pt-xl-9">
                            {{ countNumber }}
                        </div>
                        <div class="text-gray-dark text-center pt-3">
                            {{ labelCountdownRecording }}
                        </div>
                    </div>
                </div>
                <div class="fit d-flex justify-content-center align-items-center bg-white bg-gradient-blue-light border border-gray-lighten" v-if="showRecordStart">
                    <a href="#" @click.prevent="startDevice" class="" v-if="showOnlineRecords">
                        <div
                                class="pt-8 pl-8 bg-contain"
                                :style="'background-image: url('+icon+')'"
                        ></div>
                        <div class="text-gray-dark text-center pt-3">
                            {{ label }}
                        </div>
                    </a>
                    <slot name="upload" :showOnlineRecords="showOnlineRecords"></slot>
                </div>
            </slot>
        </div>
        <slot name="error">
            <div class="text-danger font-weight-normal pl-3 mt-2" v-if="error">
                <i aria-hidden="true" class="fa fa-exclamation-triangle"></i>
                {{ error }}
            </div>
        </slot>
        <slot name="after" :startUploadVideo="startUploadVideo" :uploadProgress="uploadProgress" :isLoading="isLoading" :isUploaded="isUploaded">
            <div>{{ parseInt(uploadProgress*100) }}</div>
            <div>
                <button @click="startUploadVideo()">
                    Start Upload
                </button>
            </div>
        </slot>
    </div>
</template>

<script>
    import tus from 'tus-js-client';
    import axios from 'axios';
    import localforage from 'localforage';

    //import 'recordrtc/RecordRTC.js';
    //import 'videojs-record/src/js/videojs.record.js';

    export default {
        name: 'RegisterVideo',
        //extends: BaseComponenent,
        props: {
            containerClassName: {
                type: String,
                default: 'position-relative'
            },
            className: {
                type: String,
                default: 'video-js vjs-default-skin'
            },

            icon: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },

            iconRecordAgain: {
                type: String,
                default: ''
            },
            labelRecordAgain: {
                type: String,
                default: ''
            },

            iconStartRecording: {
                type: String,
                default: ''
            },
            labelStartRecording: {
                type: String,
                default: ''
            },
            labelCountdownRecording: {
                type: String,
                default: ''
            },
            labelPlayVideo: {
                type: String,
                default: ''
            },

            defaultError: {
                type: String,
                default: ''
            },

            defaultDeviceError: {
                type: String,
                default: 'Error to webcam connection.'
            },

            defaultFormatError: {
                type: String,
                default: 'Error video format.'
            },

            uploadLink: {
                type: String,
                default: ''
            },
            defaultUploadError: {
                type: String,
                default: ''
            },
            videoName: {
                type: String,
                default: ''
            },

            width: {
                type: [Number, String],
                default: 720
            },
            height: {
                type: [Number, String],
                default: 480
            },
            mime: {
                type: String,
                default: 'video/webm\;codecs=vp8'
            },
            bps: {
                type: [Number, String],
                default: 320000
            },
            audioBps: {
                type: [Number, String],
                default: 128000
            },
            videoBps: {
                type: [Number, String],
                default: null
            },

            maxSeconds: {
                type: [String, Number],
                default: 120
            },

            storeName: {
                type: String,
                default: 'videos'
            },

            disableStoredVideo: {
                type: [String, Number, Boolean],
                default: false
            }
        },
        data() {
            return {
                clonedEl: null,

                recorder: null,
                stream: null,
                videoBlob: null,
                videoSize: 0,

                response: null,
                videoData: null,

                error: '',

                storedBlob: null,

                player: null,

                playerMode: 'recorder',
                recordDeviceReady: false,

                playerError: '',

                uploadClient: null,

                uploadProgress: 0,

                isUploaded: false,

                isLoading: false,

                showControls: true,
                showOnlineRecords: true,
                showCountdown: false,
                countNumber: 3,
                countdownTimer: null
            };
        },
        computed: {
            videoId() {
                return this.videoData ? this.videoData.id || null : null;
            },
            showRecordStart() {
                return this.playerMode === 'recorder' && !this.recordDeviceReady;
            }
        },
        watch: {
            /*response: {
                handler( resp ) {
                    const { uploadLink, video } = resp.data;
                    this.uploadLink = uploadLink;
                    this.videoData = video;
                }
            },*/
            defaultError: {
                handler(defaultError) {
                    this.error = defaultError;
                },
                deep: true
            },
            videoBlob: {
                handler(blob) {
                    this.videoSize = blob ? blob.size : 0;
                },
                deep: true
            },
            storedBlob: {
                handler(blob) {
                    this.videoSize = blob ? blob.size : 0;
                },
                deep: true
            }
        },
        async mounted() {

            this.showOnlineRecords = !(/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);

            this.clonedEl = this.$refs.video.cloneNode(true);

            this.storedBlob = await this.getSingleBlobFromStore(this.storeName);
            //this.uploadLink = await this.getUploadLink();
            this.isUploaded = await this.getUploadedStatus();
            this.uploadProgress = this.isUploaded ? 1 : 0;

            this.initPlayer();
        },
        methods: {
            initPlayer() {
                if (!+this.disableStoredVideo && this.storedBlob) {
                    this.loadPlayer(this.storedBlob);
                } else {
                    this.loadRecorder();
                }
            },
            removePlayer() {
                if (this.player && typeof this.player.dispose === 'function') {

                    this.player.dispose();
                    this.recordDeviceReady = false;
                    let clonedVideo = this.clonedEl.cloneNode(true);
                    this.$refs.videoContainer.appendChild(clonedVideo);
                    this.$refs.video = clonedVideo;
                }
            },
            startDevice() {
                this.recorder.getDevice();
            },
            getPlayerConfig(objConfig = {}) {
                return {
                    controls: true,
                    loop: false,
                    aspectRatio: '4:3',
                    fluid: true,
                    ...objConfig
                };
            },
            async loadRecorder() {
                const video = this.$refs.video;

                let fnInit = this.player && this.player.init ? this.player.init : videojs;

                let player = fnInit(
                    video,
                    this.getPlayerConfig({
                        plugins: {
                            // videojs-record plugin options
                            record: {
                                audio: true,
                                video: true,
                                videoMimeType: this.mime,
                                maxLength: +this.maxSeconds,
                                debug: true,
                                timeSlice: 2000,
                            }
                        }
                    })
                );

                this.playerMode = 'recorder';

                player.ready(function () {

                });

                player.on('deviceReady', () => {
                    this.recordDeviceReady = true;
                    this.error = '';
                });
                player.on('deviceError', () => {
                    this.recordDeviceReady = false;
                    this.error = this.defaultDeviceError;
                });

                player.on('finishRecord', async () => {
                    // the recordedData object contains the stream data that
                    // can be downloaded by the user, stored on server etc.
                    this.showControls = true;
                    this.storedBlob = this.videoBlob = player.recordedData;
                });

                player.on('ended', () => {
                    this.showControls = true;
                });
                player.on('paused', () => {
                    this.showControls = true;
                });

                player.on('timestamp', async () => {
                    let blob = player.recordedData[player.recordedData.length - 1];
                    await this.addStoreItem({
                        key: player.currentTimestamp,
                        item: {
                            blob,
                            ts: player.currentTimestamp
                        },
                        storeName: 'videos'
                    });

                });

                let recorder = player.record();
                this.player = player;
                return this.recorder = recorder;
            },
            async loadPlayer(blob) {
                const video = this.$refs.video;

                let fnInit = this.player && this.player.init ? this.player.init : videojs;

                let player = fnInit(video, this.getPlayerConfig({}));

                const _fnEvent = (evt) => {
                    const {type} = evt;

                    switch (type) {
                        case 'error' :
                            this.playerError = 'error';
                            break;
                        case 'loadedmetadata' :
                            this.playerError = '';
                            break;
                    }

                    player.off('loadedmetadata', _fnEvent);
                    player.off('error', _fnEvent);
                };

                player.one('loadedmetadata', _fnEvent);
                player.one('error', _fnEvent);

                player.src({
                    type: blob.type,
                    src: URL.createObjectURL(blob)
                });

                this.playerMode = 'player';

                this.player = player;
            },
            async getUploadedStatus(uploadLink = this.uploadLink) {
                return await this.getStoreItem(uploadLink, 'uploaded') || false;
            },
            saveUploadedStatus(status = true) {
                this.addStoreItem({
                    key: this.uploadLink,
                    item: status,
                    storeName: 'uploaded'
                });
            },
            async getBlobsFromStore(storeName) {
                let items = await this.getAllStoreItems(storeName);

                if (!items.length) return null;


                let uploadedCount = 0;

                let blobs = [];
                for (let {blob, upload = false} of items.sort((a, b) => a.ts - b.ts)) {
                    if (!blob) continue;

                    let isUploaded = !!upload;
                    uploadedCount += +isUploaded;

                    blobs.push(blob);
                }

                let uploadProgress = uploadedCount ? uploadedCount / blobs.length : 0;

                return {blobs, uploadProgress};
            },
            async getSingleBlobFromStore(storeName) {
                let blobsData = await this.getBlobsFromStore(storeName);

                if (!blobsData) return null;

                let {blobs, uploadProgress} = await this.getBlobsFromStore(storeName);

                let mergedBlob = new Blob(blobs, {type: this.mime});

                mergedBlob.uploadProgress = uploadProgress;

                return mergedBlob;
            },
            checkBlobIsAlreadyToUpload(resume = !!this.storedBlob) {
                return !!(resume ? this.storedBlob || this.videoBlob : this.videoBlob || this.storedBlob);
            },
            async startUploadVideo(uploadLink = this.uploadLink, resume = !!this.storedBlob) {
                let blobToUpload = resume ? this.storedBlob || this.videoBlob : this.videoBlob || this.storedBlob;

                // SE NESSUN VIDEO è PRESENTE
                if (!blobToUpload) {
                    this.error = this.defaultUploadError;
                    return false;
                }

                this.isLoading = true;

                if (!uploadLink) {
                    this.error = this.defaultUploadError;
                    this.isLoading = false;
                    return false;
                }

                this.isUploaded = false;
                this.saveUploadedStatus(false);


                this.isLoading = true;

                this.error = '';

                return await (async () => {
                    return new Promise(async (resolve, reject) => {
                        this.uploadClient = await this.singleUpload(blobToUpload, {
                            uploadLink,
                            onProgress: (bytesUploaded, bytesTotal) => {
                                this.uploadProgress = (bytesUploaded / bytesTotal) - 0.01;
                            },
                            onSuccess: (uploadClient) => {
                                this.uploadProgress = 1;
                                this.isUploaded = true;
                                this.saveUploadedStatus(true);
                                resolve(uploadClient);
                                this.deleteStore(this.storeName);
                                this.isLoading = false;
                            },
                            onError: (error) => {
                                this.isUploaded = false;
                                this.saveUploadedStatus(false);
                                this.error = error || this.defaultError;
                                resolve(false);
                                this.isLoading = false;
                            }
                        });
                    });
                })();
            },
            setVideoBlob(blob) {
                this.videoBlob = blob;
            },
            async deleteVideo() {
                this.showControls = true;
                this.showCountdown = false;
                this.deleteStore('videos');
                this.deleteStore('uploaded');
                this.storedBlob = this.videoBlob = null;
                this.isUploaded = false;
                this.uploadProgress = 0;
                this.player.record().getDevice();
            },
            async resetRecorder() {
                this.showControls = true;
                this.showCountdown = false;
                this.deleteStore('videos');
                this.deleteStore('uploaded');
                this.storedBlob = this.videoBlob = null;
                this.isUploaded = false;
                this.uploadProgress = 0;
                this.recordDeviceReady = false;
            },

            async singleUpload(blob, {
                uploadLink = this.uploadLink, onSuccess = () => {
                }, onProgress = () => {
                }, onError = () => {
                }
            }) {
                return new Promise((resolve, reject) => {
                    let upload = new tus.Upload(
                        blob,
                        {
                            endpoint: uploadLink,
                            uploadUrl: uploadLink,
                            uploadSize: blob.size,
                            headers: {
                                'Accept': 'application/vnd.vimeo.*+json;version=3.4',
                            },
                            //retryDelays: [0, 1000, 3000, 5000],
                            metadata: {
                                filename: this.videoName,
                                filetype: this.mime,
                            },

                            resume: false,

                            onError(error) {
                                onError(error);
                                resolve(false);
                            },
                            onProgress(bytesUploaded, bytesTotal) {
                                onProgress(bytesUploaded, bytesTotal);
                            },
                            onChunkComplete(chunkSize, bytesAccepted, bytesTotal) {
                                onProgress(chunkSize, bytesTotal);
                            },
                            onSuccess() {
                                onSuccess(upload);
                                resolve(upload);
                            }
                        },
                    );

                    //upload.url = uploadLink;

                    upload.start();
                });
            },
            async deleteStore(storeName) {
                let store = await this.getStore(storeName);

                return await store.clear();
            },
            async createStore(storeName, dbName) {
                return new Promise((resolve, reject) => {
                    let storage = localforage.createInstance({
                        driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE],
                        name: dbName,
                        storeName: storeName || this.uploadLink || 'videos'
                    });

                    resolve(storage);
                });
            },
            async getStore(storeName) {
                return await this.createStore(storeName, this.videoName);
            },
            async getAllStoreItems(storeName) {
                let store = await this.getStore(storeName);

                let items = [];

                await store.iterate((item) => {
                    items.push(item);
                });

                return items;
            },
            async getStoreItem(itemKey, storeName) {
                let store = await this.getStore(storeName);

                return await store.getItem(itemKey);
            },
            async addStoreItem({key = null, item, storeName}) {
                let store = await this.getStore(storeName);

                if (key === null) {
                    key = store.length();
                }

                await store.setItem(key, item);

                return item;
            },
            async removeStoreItem(itemKey, storeName) {
                let store = await this.getStore(storeName);

                return await store.removeItem(itemKey);
            },

            startRecording() {
                this.showControls = false;
                this.showCountdown = true;

                this.deleteStore('videos');
                this.deleteStore('uploaded');

                this.storedBlob = this.videoBlob = null;

                this.player.record().getDevice();

                this.countdownTimer = setInterval(() => {
                    this.countNumber = --this.countNumber;
                    if (this.countNumber == 0) {
                        this.showCountdown = false;
                        clearInterval(this.countdownTimer);
                        this.countNumber = 3;
                        this.player.record().start();
                    }
                }, 1000);
            },
            playVideo() {
                this.showCountdown = false;
                this.showControls = false;
                this.player.play();
            }
        }
    }
</script>
